<template>
  <common-dialog
    ref="dialog"
    title="解绑"
    width="1100px"
    :in-dialog="inDialog"
  >
    <list
      ref="list"
      common
    >
      <template #column>
        <slot name="column" />
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button
          type="primary"
          @click="selectMultiple"
          
          >确定</el-button
        >
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./commonList";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  data() {
    return {
      params: {},
    };
  },
  methods: {
    
    selectMultiple() {
      let data = this.$refs.list.sendData();

      if(data.PrUnBindMaterialDetails.length === 0){
        this.$message.error('请选择记录')
        return
      }

      if(data.DocNo === ""){
        this.$message.error('缺少单据编号')
        return
      }
      this.$emit("select", data);
      this.close();
    },
    getData(WorkDocId) {
      console.log('2 WorkDocId', WorkDocId)
      this.$nextTick(() => {
        this.$refs.list.getData(WorkDocId);
      })
    },
    treeSelect(data) {
      this.$refs.list.showTable({ ...this.params, IdChain: data.IdChain });
    },
    titleClick() {
      this.$refs.list.showTable({ ...this.params, IdChain: null });
    },
  },
};
</script>
